export function moneyEquals(left: number, right: number): boolean {
  return Math.round(left * 100) === Math.round(right * 100);
}

export function paymentAmountChoices(account: {
  dueBalanceTenantToCorp?: number;
  billedBalanceTenantToCorp?: number;
  invoice?: { remainingBalance?: number } | null;
}): { dueNow: number; billed: number } {
  const invoiceRemaining = account.invoice?.remainingBalance ?? 0;
  const dueNow =
    account.dueBalanceTenantToCorp != null
      ? Number(account.dueBalanceTenantToCorp)
      : invoiceRemaining;
  const billed =
    account.billedBalanceTenantToCorp != null
      ? Number(account.billedBalanceTenantToCorp)
      : invoiceRemaining;
  return { dueNow, billed };
}

/** Show the due-now radio only when billed AR is a higher pay-ahead amount. */
export function showDueNowChoice(dueNow: number, billed: number): boolean {
  return Math.round(dueNow * 100) > 0 && Math.round(billed * 100) > Math.round(dueNow * 100);
}

/**
 * Due now is the default when it is below billed AR. When due now is 0, do not
 * pre-select billed AR. When due now is above billed AR, select billed AR so
 * the visible radio matches the amount that can be paid.
 */
/** Billed AR radio. "Balance due" is only for the due-now choice. */
export function billedArChoiceLabel(dueNow: number, billed: number): string {
  if (showDueNowChoice(dueNow, billed) || Math.round(dueNow * 100) === 0) {
    return "Total account balance";
  }
  return "Balance due";
}

export function defaultPaymentAmountChoice(
  dueNow: number,
  billed: number
): "INVOICE_BALANCE" | "TOTAL_BALANCE" | "OTHER" {
  if (showDueNowChoice(dueNow, billed)) {
    return "INVOICE_BALANCE";
  }
  if (Math.round(dueNow * 100) === 0) {
    return "OTHER";
  }
  if (Math.round(billed * 100) > 0) {
    return "TOTAL_BALANCE";
  }
  return "OTHER";
}
